<template>
  <div>
    <v-snackbar
      top
      v-model="show"
      :style="{'margin-top': `${i * 80}px`, 'z-index': 1000 + callStatusSnackbars.length - i + ' !important'}"
      v-for="(snack,i) in callStatusSnackbars"
      :key="snack._id"
      :timeout="-1"
      min-width="600"
      light
    >
      <v-layout class="flex items-center justify-between gap-2">
        {{ $t('auto_dialer.modal_lead_status.choose_lead_status') }}
        ({{ Array(snack.phone.length - 3).join('*') +
          snack.phone.substring(snack.phone.length - 4, snack.phone.length) }})

        <div class="autocomplete-container">
          <v-select
            dense
            attach
            outlined
            item-value="value"
            :items="statusEnum"
            :placeholder="$t('auto_dialer.modal_lead_status.choose_status')"
            hide-details
            light
            @change="(e) => onChooseStatus(e, snack)"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              {{ data.item.label }}
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              {{ data.item.label }}
            </template>
          </v-select>
          <v-btn
            icon
            @click="close(snack._id)"
          >
            <v-icon
              class="cursor-pointer"
              color="black"
            >
              $close
            </v-icon>
          </v-btn>
        </div>
      </v-layout>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    statusEnum: [],
    show: true,
  }),
  created() {
    this.statusEnum = [
      { label: this.$t('auto_dialer.modal_lead_status.call_later'), value: 'call_later_back' },
      { label: this.$t('auto_dialer.modal_lead_status.callback_scheduled'), value: 'callback_scheduled' },
      { label: this.$t('auto_dialer.modal_lead_status.closed_deal'), value: 'closed_deal' },
      { label: this.$t('auto_dialer.modal_lead_status.do_not_call'), value: 'do_not_call' },
      { label: this.$t('auto_dialer.modal_lead_status.not_interested'), value: 'not_interested' },
      { label: this.$t('auto_dialer.modal_lead_status.wrong_number'), value: 'wrong_number' },
      { label: this.$t('auto_dialer.modal_lead_status.voice_mail'), value: 'voice_mail' },
      { label: this.$t('auto_dialer.modal_lead_status.under_age'), value: 'under_age' },
      { label: this.$t('auto_dialer.modal_lead_status.no_language'), value: 'no_language' },
      { label: this.$t('auto_dialer.modal_lead_status.interested'), value: 'interested' },
      { label: this.$t('auto_dialer.modal_lead_status.unqualified'), value: 'unqualified' },
      { label: this.$t('auto_dialer.modal_lead_status.soft_agreement'), value: 'soft_agreement' },
      { label: this.$t('auto_dialer.modal_lead_status.deposit'), value: 'deposit' },
    ]
  },
  computed: {
    ...mapState('leadLists', ['currentCallId', 'callStatusSnackbars']),
  },
  methods: {
    ...mapActions('leadLists', ['changeCurrentLeadInfo', 'removeCallStatusSnack']),
    close(snackId) {
      this.removeCallStatusSnack(snackId)
    },
    onChooseStatus(selectedOption, snack) {
      this.changeCurrentLeadInfo({ callId: snack.callId, status: selectedOption })
      this.removeCallStatusSnack(snack._id)
    },
  },
}
</script>

<style scoped lang="scss">
.custom-radio {
    @apply text-center p-4;

    ::v-deep label {
    @apply justify-center;
    }

    &.v-item--active {
    @apply bg-light-blue rounded-lg;
    }

    ::v-deep .v-input--selection-controls__input {
    @apply hidden;
    }
}
.v-item--active {
    ::v-deep label {
    @apply font-bold;
    }
}

.autocomplete-container {
  @apply flex gap-2 z-20;
  width: 250px;
}
</style>
